// tslint:disable

import { get } from 'lodash';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { TextAreaField } from '../../components/fields/textarea.field';
import {Field, FormLib} from '../../components/libs/form.lib';
import { ListLib } from '../../components/libs/list.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import { MediaItemPresenter } from '../../components/structurals/presenters/media-item-presenter';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import {MediaItemField} from "../../components/fields/media-item.field";
import axios, {AxiosResponse} from "axios";
import {Environment} from "../../environment/environment";

// import * as $ from "jquery";
// import * as $ from 'jquery';


export class DefaultMediaAlbum extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public images:Field;

    public state: any = {
        images: []
    }

    componentDidMount() {
        this.images = new Field({property: 'images', multi: true});
        this.images.registerField();

        this.images.onNEVERUSEONLYFORTHESPECIALHiddenValueChanges$.debounceTime(200).subscribe(async (values: any) => {
            await Promise.all((values[0] || []).map(async (value: any) => {

                let id = this.props.ENTITY_ID.replace('/media-album/', '');



                await axios.post(`${Environment.get('api.base')}/media-album-image`, {
                    album: `/media-album/${id}`,
                    image: value
                }, {
                    withCredentials: true,
                })
            }));
            this.fetchAlbumItems();
        });

        this.fetchAlbumItems();
    }

    public async saveForm(form: FormLib): Promise<any> {

        if (this.props.CONFIG.article) {
            form.fields.article.registerField();
            form.fields.article.setValue([this.props.CONFIG.article]);
        }

        this.executor.updateForm(form);
        await this.executor.exec();




    }

    public async fetchAlbumItems() {
        const response: AxiosResponse = await axios.get(`${Environment.get('api.base')}/media-album-image`, {
            withCredentials: true,
            params: {
                album: this.props.ENTITY_ID,
                pagination: false,
                'order[position]': 'ASC'
            }
        });

        this.setState({images: get(response.data, 'hydra:member')})
    }

    public sortableAction (event: any, ui: any) {

        let id = $(ui.item).attr('id');
        let index = ui.item.index() + 1;

        axios.put(`${Environment.get('api.base')}/media-album-image/${id}`, {
            position: index
        }, {
            withCredentials: true,
        })

    }

    render() {
        return (
            <ResourceLoader
                entity="media-album"
                entityId={this.props.ENTITY_ID}
                render={(form: FormLib, raw: any) => <div className="row">
                    <LoaderComponent isLoading$={this.executor.loading$}/>

                    <div className="col-xs-12">
                        <ToggleBoxComponent title="Media album informations" alwaysOpen={true}>
                            <div className="row">
                                <InputField
                                    className="col-xs-12"
                                    field={form.fields.title}
                                    validators={[Validators.required('Required')]}/>

                                <InputField
                                    className="col-xs-12"
                                    field={form.fields.subTitle}
                                />

                                <TextAreaField
                                    className="col-xs-12"
                                    field={form.fields.description}
                                />
                            </div>
                        </ToggleBoxComponent>

                        {this.props.IS_UPDATE &&
                            <div><MediaItemField
                                field={this.images}
                                hideThumbnail={true}
                            />
                            {this.state.images &&
                                    <ListResponsePresenterTable
                                        head={() => this.head()}
                                        row={(item: any, index: number, actions: ListActions) => this.rowRaw(item, index, actions)}
                                        items={this.state.images}
                                        sortable={true}
                                        sortableAction={this.sortableAction}
                                    />
                            }</div>
                        }


{/*                        {this.props.IS_UPDATE && <ToggleBoxComponent title="Media Items">
                            <ListResourceLoader
                                entity="media-album-image"
                                forceQuery={{album: this.props.ENTITY_ID}}
                                render={(list: ListLib) => <div>
                                    <ListResponsePresenterTable
                                        head={() => this.head()}
                                        row={(item: any, index: number, actions: ListActions) => this.row(item, index, actions, list)}
                                        items={list.member}/>
                                    <div className="mt-3">
                                        <ResourceModal
                                            entity={'media-album-image'}
                                            entityId={'create'}
                                            title="Add Image"
                                            onCreateSuccessful={() => list.refetch()}
                                            config={{album: `/media-album/${this.props.ENTITY_ID}`}}
                                        />
                                    </div>
                                </div>}/>
                        </ToggleBoxComponent>}*/}
                    </div>

                    {this.props.IS_CREATE &&
                    <div className="col-xs-12">
                        <button className="btn btn-primary pull-left"
                                onClick={() => this.saveForm(form)}>Save
                        </button>
                    </div>
                    }

                </div>}
            />
        );
    }

    private head() {
        return <tr>
            <th style={{textAlign: 'center'}}><i className="fa fa-arrows-v" aria-hidden="true"/></th>
            <th>Title</th>
            <th>Action</th>
        </tr>;
    }

    public row(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index} id={item.id}>
            <td><MediaItemPresenter iri={item.image['@id']} width={120} size="original"/></td>
            <td>{get(item, '@id', 'N/A')}</td>
            <td>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit Image'}
                        entity={'media-album-image'}
                        config={{album: `/media-album/${this.props.ENTITY_ID}`}}
                        entityId={item.id || item['@id'].replace('/media-album-image/', '')}
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Delete Image
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }
    private rowRaw(item: any, index: number, actions: ListActions) {
        return <tr key={index} id={item.id}>
            <td style={{textAlign: 'center', cursor: 'ns-resize'}}><i className="fa fa-arrows-v" aria-hidden="true"/></td>
            <td>
                <MediaItemPresenter iri={item.image['@id']} width={300} size="720_560i"/>
            </td>
            <td>
                <a onClick={(event: any) => this.deleteAlbumItem(item)} style={{cursor: 'pointer'}}>
                    Delete
                </a>
            </td>
        </tr>;
    }

    private async deleteAlbumItem (item: any) {
        axios.delete(`${Environment.get('api.base')}${item['@id']}`, {
            withCredentials: true,
        }).then(() => {
            this.fetchAlbumItems();
        })
    }

    private async handleDelete(item: any, list: ListLib, ListActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        try {
            list.isLoading$.next(true);
            await ListActions.delete(item['@id']);
        } catch (error) {
            // Silence is golden
        } finally {
            list.refetch();
        }
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.media-album.tsx